import { render, staticRenderFns } from "./OfertaPage.vue?vue&type=template&id=cd1afe3e&"
import script from "./OfertaPage.vue?vue&type=script&lang=js&"
export * from "./OfertaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports